import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useCallback, useRef } from 'react';
import { useFeatureFlagClient, useFeatureFlagAuth } from '../context/FeatureFlagContext';
/**
 * Hook to evaluate a single feature flag.
 * Must be used within a FeatureFlagProvider.
 */

export function useFeatureFlag(key) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var client = useFeatureFlagClient();
  var authToken = useFeatureFlagAuth(); // Initialize from cache if available to avoid false default

  var cachedValue = client.getCachedValue(key);

  var _useState = useState(cachedValue !== null ? cachedValue.enabled : false),
      _useState2 = _slicedToArray(_useState, 2),
      isEnabled = _useState2[0],
      setIsEnabled = _useState2[1];

  var _useState3 = useState(cachedValue === null),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = useState(cachedValue),
      _useState8 = _slicedToArray(_useState7, 2),
      evaluation = _useState8[0],
      setEvaluation = _useState8[1];

  var isMountedRef = useRef(true);
  useEffect(function () {
    isMountedRef.current = true;
    return function () {
      isMountedRef.current = false;
    };
  }, []);
  var evaluateFlag = useCallback(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var cached, hasCachedValue, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (authToken) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            // Check if we have a cached value - if so, don't show loading state
            cached = client.getCachedValue(key);
            hasCachedValue = cached !== null;

            if (!hasCachedValue && isMountedRef.current) {
              setIsLoading(true);
            }

            if (isMountedRef.current) {
              setError(null);
            }

            _context.prev = 6;
            _context.next = 9;
            return client.evaluateFlag(key);

          case 9:
            result = _context.sent;

            if (isMountedRef.current) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return");

          case 12:
            if (result) {
              setEvaluation(result);
              setIsEnabled(result.enabled);
            } else {
              setEvaluation(null);
              setIsEnabled(false);
            }

            _context.next = 22;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](6);

            if (isMountedRef.current) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return");

          case 19:
            setError(_context.t0 instanceof Error ? _context.t0.message : 'Unknown error');
            setIsEnabled(false);
            setEvaluation(null);

          case 22:
            _context.prev = 22;

            if (isMountedRef.current) {
              setIsLoading(false);
            }

            return _context.finish(22);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 15, 22, 25]]);
  })), [key, authToken, client]); // Only fetch when we have a valid auth token

  useEffect(function () {
    if (authToken) {
      evaluateFlag();
    }
  }, [evaluateFlag, authToken, key]); // Set up refresh interval if specified (only when authenticated)

  useEffect(function () {
    if (authToken && options.refreshInterval && options.refreshInterval > 0) {
      var interval = setInterval(evaluateFlag, options.refreshInterval);
      return function () {
        return clearInterval(interval);
      };
    }

    return undefined;
  }, [evaluateFlag, options.refreshInterval, authToken]);
  return {
    isEnabled: isEnabled,
    isLoading: isLoading,
    error: error,
    evaluation: evaluation,
    refresh: evaluateFlag
  };
}